import { useActionEngine } from '../composables/useActionEngine.js';

// The plugin actionEngine is used to register and setup the Action Engine instance; used for handling
// user-defined actions that run in certain conditions (e.g. on selection changes, on button clicks, on context menu clicks, etc.)
// See composables useAction* for more details and implementation.

export const ACTION_ENGINE_KEY = Symbol('actionEngine');    // Symbol for injection key to avoid naming conflicts

export default {
	install(app, options = {}) {
		// Create one instance only and re-use it, providing it globally.
		const actionEngine = useActionEngine();
		app.provide(ACTION_ENGINE_KEY, actionEngine);
		app.config.globalProperties.$actionEngine = actionEngine;

		// Register the preset nodes and connections if provided in options
		try {
			if (options.nodes && Array.isArray(options.nodes)) {
				for (const node of options.nodes) {
					actionEngine.registerNode(node.id, node);
				}
			}
			if (options.connections && Array.isArray(options.connections)) {
				for (const connection of options.connections) {
					actionEngine.createConnection(connection.sourceId, connection.targetId, connection.socketFrom, connection.socketTo);
				}
			}
		} catch (exception) {
			throw new Error("Couldn't register preset nodes/connections: " + exception.message);
		}

		// Set debug mode if specified
		if (options.debug) {
			actionEngine.toggleDebugMode();
		}

		console.log('Action Engine plugin installed.');
	}
}; 